/* /tw/lang.js */
export default {
    "CustomerLogin": "會員登入",
    "Account": "帳號",
    "Password": "密碼",
    "Login" : "登入"
}
